import {AccessLevelToggle} from "../../model/AccessLevelToggle";
import './access-level-grid.component.scss';
import {IComponentController} from "angular";
import {AccessLevelConfig} from "../../model/AccessLevelConfig";

export class AccessLevelGridComponent implements IComponentController {

    public static instance = {
        template: require('./access-level-grid.component.html'),
        controller: [AccessLevelGridComponent],
        bindings: {
            accessLevels: '=',
            accessLevelConfig: '<'
        }
    };

    private accessLevels: AccessLevelToggle[];
    private accessLevelConfig: AccessLevelConfig;

    $onInit() {
        this.accessLevelConfig = this.accessLevelConfig || {
            disabled: false
        }
    }


}